export const DEFAULT_PAGE = 1;
export const DEFAULT_SORT_DIRECTION = 'ASC';
export const DEFAULT_ORDER_BY_KEY = 'projectName';

export const STATUS_TABS: Array<string> = ['all', 'progress', 'hold', 'completed'];

export const CHOOSE_TIME_LIST = [15, 30, 45, 60, 90];
